import { render } from "./job-header.vue?vue&type=template&id=81b5b638"
import script from "./job-header.vue?vue&type=script&lang=js"
export * from "./job-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__